import { IPermissionsContext } from "../../ipermissions-context/ipermissions-context.interface";
import { IPermissions } from "../../ipermissions/ipermissions.interface";
import {
  hasUserGroup,
  isDraft,
  isPageTypeCampaignBrief,
  isPageTypeExecutionBriefOrWorkOrder,
  isPageTypeWorkOrder,
} from "../../ipermissions-context/ipermissions-context.functions";
import { UserGroup } from "../../../../../constants/types";
import {
  enablePermissionIf,
  enablePermissions,
  setPermissions,
} from "../../ipermissions/ipermissions.functions";
import { IPermissionPolicyEvaluator } from "../../ipermissions/ipermission-policy.type";

export const productionDirectorGroupPolicy = (next?: IPermissionPolicyEvaluator) => (
  context: IPermissionsContext,
  permissions: IPermissions
) => {
  if (hasUserGroup(context, UserGroup.PRODUCTION_DIRECTORS)) {
    // console.log("checkProductionDirectorPolicy --> TRUE");

    enablePermissions(permissions, "manageStatus");
    enablePermissions(permissions, "manageCampBriefs");

    if (isPageTypeCampaignBrief(context)) {
      enablePermissions(permissions, "manageExecBriefs");
    } else if (isPageTypeExecutionBriefOrWorkOrder(context)) {
      setPermissions(permissions, true, "canEdit", "manageProducts");
      setPermissions(permissions, isDraft(context), "manageReviewers");
      enablePermissions(permissions, "updateReviewStatus", "manageWorkOrders");
      enablePermissionIf(permissions, isPageTypeWorkOrder(context), "canArchive");
    }
  }

  if (next) {
    return next(context, permissions);
  }
};
